import React from "react";

interface IconPlusProps {
  color: string;
}

const IconPlus: React.FC<IconPlusProps> = ({ color }) => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="plus-icon-title"
    >
      <title id="plus-icon-title">Plus icon</title>
      <path
        d="M3.15925 4.21233H0.526542C0.377355 4.21233 0.252301 4.16187 0.151381 4.06095C0.0504602 3.96003 0 3.83498 0 3.68579C0 3.5366 0.0504602 3.41155 0.151381 3.31063C0.252301 3.20971 0.377355 3.15925 0.526542 3.15925H3.15925V0.526542C3.15925 0.377355 3.20971 0.252301 3.31063 0.151381C3.41155 0.0504602 3.5366 0 3.68579 0C3.83498 0 3.96003 0.0504602 4.06095 0.151381C4.16187 0.252301 4.21233 0.377355 4.21233 0.526542V3.15925H6.84504C6.99423 3.15925 7.11928 3.20971 7.2202 3.31063C7.32112 3.41155 7.37158 3.5366 7.37158 3.68579C7.37158 3.83498 7.32112 3.96003 7.2202 4.06095C7.11928 4.16187 6.99423 4.21233 6.84504 4.21233H4.21233V6.84504C4.21233 6.99423 4.16187 7.11928 4.06095 7.2202C3.96003 7.32112 3.83498 7.37158 3.68579 7.37158C3.5366 7.37158 3.41155 7.32112 3.31063 7.2202C3.20971 7.11928 3.15925 6.99423 3.15925 6.84504V4.21233Z"
        fill={color}
      />
    </svg>
  );
};

export default IconPlus;
